import { ReadinessSurveyAthleteGraphTransformer } from './ReadinessSurveyAthleteGraphTransformer';
import { LiftOneRepMaxHistoryGraphTransformer } from './LiftOneRepMaxHistoryGraphTransformer';
import { TrainingSummaryAthleteGraphTransformer } from './TrainingSummaryAthleteGraphTransformer';
import { MarketplaceAttributionsGraphTransformer } from './MarketplaceAttributionsGraphTransformer';
import { ANALYTICS_TYPES } from '../../view/common/constants';

export const graphTransformerFactory = (metaKey, dateParams, title = '') => {
    switch (metaKey) {
        case ANALYTICS_TYPES.READINESS_SURVEY_ATHLETE:
            return new ReadinessSurveyAthleteGraphTransformer(dateParams);
        case ANALYTICS_TYPES.LIFT_ONE_REP_MAX_HISTORY:
            return new LiftOneRepMaxHistoryGraphTransformer(dateParams);
        case ANALYTICS_TYPES.TRAINING_SUMMARY_ATHLETE:
            return new TrainingSummaryAthleteGraphTransformer(dateParams);
        case ANALYTICS_TYPES.MARKETPLACE_ATTRIBUTIONS:
            return new MarketplaceAttributionsGraphTransformer(
                dateParams,
                title
            );
        default:
            return new DisabledGraphTransformer();
    }
};

export class DisabledGraphTransformer {
    transformData(data) {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/lib/transformer/GraphTransformerFactory.js